module.exports = __webpack_public_path__ + "static/media/wb.dd897a17.svg";